var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1875 9C3.1875 8.68934 3.43934 8.4375 3.75 8.4375H14.25C14.5607 8.4375 14.8125 8.68934 14.8125 9C14.8125 9.31066 14.5607 9.5625 14.25 9.5625H3.75C3.43934 9.5625 3.1875 9.31066 3.1875 9Z",
    fill: "#542F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60225 3.35225C8.82192 3.13258 9.17808 3.13258 9.39775 3.35225L14.6477 8.60225C14.8674 8.82192 14.8674 9.17808 14.6477 9.39775L9.39775 14.6477C9.17808 14.8674 8.82192 14.8674 8.60225 14.6477C8.38258 14.4281 8.38258 14.0719 8.60225 13.8523L13.4545 9L8.60225 4.14775C8.38258 3.92808 8.38258 3.57192 8.60225 3.35225Z",
    fill: "#542F1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBrown);
export default __webpack_public_path__ + "static/media/arrow-right-brown.80b62063e931e51ed7c84585a92c22cb.svg";
export { ForwardRef as ReactComponent };